"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrepDataSourceStatus = void 0;
var Utils_1 = require("./Utils");
var getPrepDataSourceStatus = function (isFlowPublished, modelOutcomeList) {
    if (!isFlowPublished) {
        return Utils_1.PrepDataSourceStatus.flowNotPublished;
    }
    if (modelOutcomeList === undefined) {
        return Utils_1.PrepDataSourceStatus.columnsNotReceived;
    }
    if (modelOutcomeList.length === 0) {
        return Utils_1.PrepDataSourceStatus.connectionError;
    }
    var isColumnWithinLimitations = modelOutcomeList.length >= 3 && modelOutcomeList.length <= 50;
    if (!isColumnWithinLimitations) {
        return Utils_1.PrepDataSourceStatus.columnSizeError;
    }
    return Utils_1.PrepDataSourceStatus.none;
};
exports.getPrepDataSourceStatus = getPrepDataSourceStatus;
//# sourceMappingURL=StateSelectorUtils.js.map